import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PrintIcon from "Assets/SVG/PrintIcon";
import React from "react";
import FoilTypeForm from "../../../Features/Prints/Components/FoilTypeForm";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newFoilType')} icon={<PrintIcon />} includeBox>
            <FoilTypeForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
